/**
 * Internal dependencies
 */
import { isTextBoxAttachment } from '../../../utils/textBoxAttachment';

function getTransformableElements(selectedElements) {
  const selectedById = new Map(
    selectedElements.map((element) => [element.id, element])
  );
  const transformable = new Map();

  selectedElements.forEach((element) => {
    const path = new Set();
    let current = element;
    let canTransform = false;
    while (current && !path.has(current.id)) {
      if (transformable.has(current.id)) {
        canTransform = transformable.get(current.id);
        break;
      }
      path.add(current.id);
      if (!isTextBoxAttachment(current.textBoxAttachment)) {
        canTransform = true;
        break;
      }
      current = selectedById.get(current.textBoxAttachment.targetId);
    }
    path.forEach((id) => transformable.set(id, canTransform));
  });

  return selectedElements.filter(({ id }) => transformable.get(id));
}

export default getTransformableElements;
